import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const skillApi = createApi({
  reducerPath: 'skillApi',
  baseQuery: rtkBaseQuery('/staff/Skill'),
  endpoints: (builder) => ({
    getSkillById: builder.query({
      query: (id) => `/GetSkillById?skillId=${id}`,
    }),
    addSkill: builder.mutation({
      query: ({ nameUz, nameRu, formData }) => {
        return {
          url: '/AddSkill',
          method: 'POST',
          params: { nameUz, nameRu },
          body: formData,
          responseHandler: (response) => response.text(),
        };
      },
    }),
    updateSkill: builder.mutation({
      query: ({ skillId, nameUz, nameRu, formData }) => ({
        url: '/UpdateSkill',
        method: 'PUT',
        params: { skillId, nameUz, nameRu },
        body: formData,
      }),
      transformResponse: (response, meta) => {
        if (meta.response?.status === 200) {
          return { success: true, message: 'Skill successfully updated' };
        }
        return response;
      },
      transformErrorResponse: (response) => {
        return { error: true, status: response.status, message: 'Failed to update skill' };
      },
    }),
    deleteSkill: builder.mutation({
      query: ({ skillId }) => ({
        url: `/DeleteSkill?skillId=${skillId}`,
        method: 'DELETE',
      }),
      transformResponse: (response, meta) => {
        if (meta.response?.status === 200) {
          return { success: true, message: 'Skill successfully deleted' };
        }
        return response;
      },
      transformErrorResponse: (response) => {
        return { error: true, status: response.status, message: 'Failed to delete skill' };
      },
    }),
  }),
});

export const {
  useAddSkillMutation,
  useUpdateSkillMutation,
  useDeleteSkillMutation,
  useGetSkillByIdQuery,
} = skillApi;
